import "./../../../../pages/audit complet/simulation/simulation.css";
import "./CorrectionPER.css";
import "../../AuditComplet/ContexteFiscal/ContexteFiscal.css";
import { useState, useContext, useEffect } from "react";
import { FaEdit, FaPrint, FaUndo, FaFileAlt, FaCalculator, FaArrowLeft, FaSave } from "react-icons/fa";
import Button from "components/ui/controls/button/button";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import DropDown from "components/ui/controls/drop-down/drop-down";
import { SyntheseCorrectionPER } from "components/app/Api/Rapport/ApiRapport";
import _ from "lodash";
import { GetCalculCorrectionPER } from "components/app/Api/ApiSimulateur";
import CorrrectionPERAnnee from "./CorrectionPERAnnee";
import ActionButton from "components/ui/controls/action-button/ActionButton";
import { useStudyManagementHandlers } from "pages/studyManagementHandler";

const CorrectionPER = (props) => {
  const dt = new Date();
  const yearM1 = dt.getFullYear() - 1;
  const yearM2 = dt.getFullYear() - 2;
  const yearM3 = dt.getFullYear() - 3;
  const year = dt.getFullYear();

  const context = useContext(AppContext);
  const [clientConjoint, setClientConjoint] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [yearToModify, setYearToModify] = useState(0);
  const [plafondClient, setPlafondClient] = useState(0);
  const [plafondConjoint, setPlafondConjoint] = useState(0);
  const { handleSave, handleGoToAudits } = useStudyManagementHandlers(props);
  const initialValues = {
    DeclaPERRemunerationImposable: 0,
    DeclaPERRegimeFiscal: "tns",
    DeclaPERAbondementPERCO: 0,
    DeclaPERRetraiteMadelin: 0,
    DeclaPERPrevoyanceMadelin: 0,
    DeclaPERRetraite83: 0,
    DeclaPERRetraite163: 0,
    DispoPERCorrige: 0,
    DeclaPERRemunerationImposableConjoint: 0,
    DeclaPERRegimeFiscalConjoint: "tns",
    DeclaPERAbondementPERCOConjoint: 0,
    DeclaPERRetraiteMadelinConjoint: 0,
    DeclaPERPrevoyanceMadelinConjoint: 0,
    DeclaPERRetraite83Conjoint: 0,
    DeclaPERRetraite163Conjoint: 0,
    DispoPERCorrigeConjoint: 0,
  };

  //INIT DU TABLEAU DES CORRECTIONS PER
  const [tabCorrectionPER, setTabCorrectionPER] = useState({});
  useEffect(() => {
    let InitValues = _.cloneDeep(context.state.CorrectionPER);
    if (!(year in InitValues)) {
      InitValues[year] = { ...initialValues };
    }
    if (!(yearM1 in InitValues)) {
      InitValues[yearM1] = { ...initialValues };
    }
    if (!(yearM2 in InitValues)) {
      InitValues[yearM2] = { ...initialValues };
    }
    if (!(yearM3 in InitValues)) {
      InitValues[yearM3] = { ...initialValues };
    }
    setTabCorrectionPER(InitValues);
    handleCalculPlafondDeduction(InitValues, context.state.CorrectionPERMutuPlafond);
  }, []);

  const handleResetCorrectionPER = () => {
    let InitValues = {};
    InitValues[year] = { ...initialValues };
    InitValues[yearM1] = { ...initialValues };
    InitValues[yearM2] = { ...initialValues };
    InitValues[yearM3] = { ...initialValues };
    setTabCorrectionPER(InitValues);
    handleCalculPlafondDeduction(InitValues, context.state.CorrectionPERMutuPlafond);
  };

  const handleChangeValue = (Year, Property, Value) => {
    let NewValues = _.cloneDeep(tabCorrectionPER);
      NewValues[Year][Property] = Value;
    setTabCorrectionPER(NewValues);
    handleCalculPlafondDeduction(NewValues, context.state.CorrectionPERMutuPlafond);
  };

  const handleCalcul = (Year, ClientConjoint) => {
    GetCalculCorrectionPER(tabCorrectionPER[Year], Year, ClientConjoint, "CalculCorrectionPER").then((res) => {
      if (typeof res === "object") {
        let NewValues = _.cloneDeep(tabCorrectionPER);

        NewValues[Year]["DispoPERCorrige" + ClientConjoint] = res.DispoPERCorrige;
        GetCalculCorrectionPER(NewValues, "", ClientConjoint, "CalculAllCorrectionPER").then((res2) => {
          if (typeof res === "object") {
            NewValues[yearM3]["DispoPERCorrige" + ClientConjoint] = res2[yearM3];
            NewValues[yearM2]["DispoPERCorrige" + ClientConjoint] = res2[yearM2];
            NewValues[yearM1]["DispoPERCorrige" + ClientConjoint] = res2[yearM1];
            NewValues[year]["DispoPERCorrige" + ClientConjoint] = res2[year];
            setTabCorrectionPER(NewValues);
            handleCalculPlafondDeduction(NewValues, context.state.CorrectionPERMutuPlafond);
          }
        });

        // handleChangeValue(Year, "DispoPERCorrige" + ClientConjoint, res.DispoPERCorrige);
      }
    });
  };


  const handleMutuPlafond = (value) => {
    context.handleValueChange("CorrectionPERMutuPlafond", value);
    handleCalculPlafondDeduction(tabCorrectionPER, value);
  };
  const handleCalculPlafondDeduction = (Values, MutuPlafond) => {
    let PlafondClient =
      Number(Values[year]["DispoPERCorrige"]) + Number(Values[yearM1]["DispoPERCorrige"]) + Number(Values[yearM2]["DispoPERCorrige"]) + Number(Values[yearM3]["DispoPERCorrige"]);
    let PlafondConjoint =
      Number(Values[year]["DispoPERCorrigeConjoint"]) +
      Number(Values[yearM1]["DispoPERCorrigeConjoint"]) +
      Number(Values[yearM2]["DispoPERCorrigeConjoint"]) +
      Number(Values[yearM3]["DispoPERCorrigeConjoint"]);
    if (MutuPlafond === "oui") {
      PlafondClient += PlafondConjoint;
      PlafondConjoint = 0;
    }
    setPlafondClient(PlafondClient);
    setPlafondConjoint(PlafondConjoint);
    context.handleValueChange("CorrectionPER", Values);
    context.handleValueChange("CorrectionPERPlafondClient", PlafondClient);
    context.handleValueChange("CorrectionPERPlafondConjoint", PlafondConjoint);
  };

  return (
    <>
      <Column fill>
        
        <Row style={{ alignItems: "stretch" }} className="declaration-per-layout">
          <Column fill style={{ minWidth: "700px", maxWidth: "820px", display: "flex", flexDirection: "column" }} className="declaration-per-left-column">
            <CardBox className="blockRoundedForce" bpad style={{ flex: 1, padding: "25px", height: "100%" }}>
              <div className="revenuspro-container" style={{ marginBottom: "20px", height: "100%", paddingLeft: "0px" }}>
                {/* Titre au-dessus du tableau */}
                <div className="dossier-header" style={{ marginBottom: "15px" }}>
                  <div className="dossier-header-icon">
                    <FaFileAlt />
                  </div>
                  <h1 className="dossier-header-title">Versements PER déductibles dans le cadre de l'article 163 quatervicies du CGI pour {year}</h1>
                </div>

                {/* Header des colonnes */}
                <div className="header-card">
                  <div className="category-column" style={{ textAlign: "left", flex: 6 }}>
                    Plafonds
                  </div>
                  <div className="value-column" style={{ textAlign: "center" }}>
                    Client
                  </div>
                  <div className="value-column" style={{ textAlign: "center" }}></div>
                  <div className="value-column" style={{ textAlign: "center" }}>
                    Conjoint
                  </div>
                  <div className="value-column" style={{ textAlign: "center" }}></div>
                </div>

                {/* Conteneur des cartes de contenu */}
                <div className="card-list-container" style={{ flex: 1 }}>
                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">📅</div>
                      Plafond non utilisé pour les revenus de {yearM3}
                    </div>
                    <div className="value-column">
                      <TextField
                        value={tabCorrectionPER[yearM3]?.DispoPERCorrige}
                        onChange={(e) => {
                          handleChangeValue(yearM3, "DispoPERCorrige", e.target.value);
                        }}
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                        iconAfter={
                          <Button
                            tabIndex="-1"
                            icon
                            onClick={() => {
                              setYearToModify(yearM3);
                              setClientConjoint("");
                              setOpenModal(true);
                            }}
                            style={{
                              backgroundColor: "#dcfce7",
                              borderRadius: "6px",
                              padding: "6px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              minWidth: "32px",
                              minHeight: "28px",
                              cursor: "pointer",
                              transition: "all 0.2s ease",
                            }}
                            onMouseOver={(e) => {
                              e.currentTarget.style.backgroundColor = "#bbf7d0";
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.backgroundColor = "#dcfce7";
                            }}
                          >
                            <FaEdit style={{ color: "#22c55e", fontSize: "12px" }} />
                          </Button>
                        }
                      />
                    </div>
                    <div className="value-column">
                      <TextField
                        value={tabCorrectionPER[yearM3]?.DispoPERCorrigeConjoint}
                        onChange={(e) => {
                          handleChangeValue(yearM3, "DispoPERCorrigeConjoint", e.target.value);
                        }}
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                        iconAfter={
                          <Button
                            tabIndex="-1"
                            icon
                            onClick={() => {
                              setYearToModify(yearM3);
                              setClientConjoint("Conjoint");
                              setOpenModal(true);
                            }}
                            style={{
                              backgroundColor: "#dcfce7",
                              borderRadius: "6px",
                              padding: "6px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              minWidth: "32px",
                              minHeight: "28px",
                              cursor: "pointer",
                              transition: "all 0.2s ease",
                            }}
                            onMouseOver={(e) => {
                              e.currentTarget.style.backgroundColor = "#bbf7d0";
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.backgroundColor = "#dcfce7";
                            }}
                          >
                            <FaEdit style={{ color: "#22c55e", fontSize: "12px" }} />
                          </Button>
                        }
                      />
                    </div>
                  </div>

                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">📅</div>
                      Plafond non utilisé pour les revenus de {yearM2}
                    </div>
                    <div className="value-column">
                      <TextField
                        value={tabCorrectionPER[yearM2]?.DispoPERCorrige}
                        onChange={(e) => {
                          handleChangeValue(yearM2, "DispoPERCorrige", e.target.value);
                        }}
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                        iconAfter={
                          <Button
                            tabIndex="-1"
                            icon
                            onClick={() => {
                              setYearToModify(yearM2);
                              setClientConjoint("");
                              setOpenModal(true);
                            }}
                            style={{
                              backgroundColor: "#dcfce7",
                              borderRadius: "6px",
                              padding: "6px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              minWidth: "32px",
                              minHeight: "28px",
                              cursor: "pointer",
                              transition: "all 0.2s ease",
                            }}
                            onMouseOver={(e) => {
                              e.currentTarget.style.backgroundColor = "#bbf7d0";
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.backgroundColor = "#dcfce7";
                            }}
                          >
                            <FaEdit style={{ color: "#22c55e", fontSize: "12px" }} />
                          </Button>
                        }
                      />
                    </div>
                    <div className="value-column">
                      <TextField
                        value={tabCorrectionPER[yearM2]?.DispoPERCorrigeConjoint}
                        onChange={(e) => {
                          handleChangeValue(yearM2, "DispoPERCorrigeConjoint", e.target.value);
                        }}
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                        iconAfter={
                          <Button
                            tabIndex="-1"
                            icon
                            onClick={() => {
                              setYearToModify(yearM2);
                              setClientConjoint("Conjoint");
                              setOpenModal(true);
                            }}
                            style={{
                              backgroundColor: "#dcfce7",
                              borderRadius: "6px",
                              padding: "6px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              minWidth: "32px",
                              minHeight: "28px",
                              cursor: "pointer",
                              transition: "all 0.2s ease",
                            }}
                            onMouseOver={(e) => {
                              e.currentTarget.style.backgroundColor = "#bbf7d0";
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.backgroundColor = "#dcfce7";
                            }}
                          >
                            <FaEdit style={{ color: "#22c55e", fontSize: "12px" }} />
                          </Button>
                        }
                      />
                    </div>
                  </div>

                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">📅</div>
                      Plafond non utilisé pour les revenus de {yearM1}
                    </div>
                    <div className="value-column">
                      <TextField
                        value={tabCorrectionPER[yearM1]?.DispoPERCorrige}
                        onChange={(e) => {
                          handleChangeValue(yearM1, "DispoPERCorrige", e.target.value);
                        }}
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                        iconAfter={
                          <Button
                            tabIndex="-1"
                            icon
                            onClick={() => {
                              setYearToModify(yearM1);
                              setClientConjoint("");
                              setOpenModal(true);
                            }}
                            style={{
                              backgroundColor: "#dcfce7",
                              borderRadius: "6px",
                              padding: "6px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              minWidth: "32px",
                              minHeight: "28px",
                              cursor: "pointer",
                              transition: "all 0.2s ease",
                            }}
                            onMouseOver={(e) => {
                              e.currentTarget.style.backgroundColor = "#bbf7d0";
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.backgroundColor = "#dcfce7";
                            }}
                          >
                            <FaEdit style={{ color: "#22c55e", fontSize: "12px" }} />
                          </Button>
                        }
                      />
                    </div>
                    <div className="value-column">
                      <TextField
                        value={tabCorrectionPER[yearM1]?.DispoPERCorrigeConjoint}
                        onChange={(e) => {
                          handleChangeValue(yearM1, "DispoPERCorrigeConjoint", e.target.value);
                        }}
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                        iconAfter={
                          <Button
                            tabIndex="-1"
                            icon
                            onClick={() => {
                              setYearToModify(yearM1);
                              setClientConjoint("Conjoint");
                              setOpenModal(true);
                            }}
                            style={{
                              backgroundColor: "#dcfce7",
                              borderRadius: "6px",
                              padding: "6px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              minWidth: "32px",
                              minHeight: "28px",
                              cursor: "pointer",
                              transition: "all 0.2s ease",
                            }}
                            onMouseOver={(e) => {
                              e.currentTarget.style.backgroundColor = "#bbf7d0";
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.backgroundColor = "#dcfce7";
                            }}
                          >
                            <FaEdit style={{ color: "#22c55e", fontSize: "12px" }} />
                          </Button>
                        }
                      />
                    </div>
                  </div>

                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">🧮</div>
                      Plafond calculé sur les revenus de {yearM1}
                    </div>
                    <div className="value-column">
                      <TextField
                        value={tabCorrectionPER[year]?.DispoPERCorrige}
                        onChange={(e) => {
                          handleChangeValue(year, "DispoPERCorrige", e.target.value);
                        }}
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                        iconAfter={
                          <Button
                            tabIndex="-1"
                            icon
                            onClick={() => {
                              setYearToModify(year);
                              setClientConjoint("");
                              setOpenModal(true);
                            }}
                            style={{
                              backgroundColor: "#dcfce7",
                              borderRadius: "6px",
                              padding: "6px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              minWidth: "32px",
                              minHeight: "28px",
                              cursor: "pointer",
                              transition: "all 0.2s ease",
                            }}
                            onMouseOver={(e) => {
                              e.currentTarget.style.backgroundColor = "#bbf7d0";
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.backgroundColor = "#dcfce7";
                            }}
                          >
                            <FaEdit style={{ color: "#22c55e", fontSize: "12px" }} />
                          </Button>
                        }
                      />
                    </div>
                    <div className="value-column">
                      <TextField
                        value={tabCorrectionPER[year]?.DispoPERCorrigeConjoint}
                        onChange={(e) => {
                          handleChangeValue(year, "DispoPERCorrigeConjoint", e.target.value);
                        }}
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                        iconAfter={
                          <Button
                            tabIndex="-1"
                            icon
                            onClick={() => {
                              setYearToModify(year);
                              setClientConjoint("Conjoint");
                              setOpenModal(true);
                            }}
                            style={{
                              backgroundColor: "#dcfce7",
                              borderRadius: "6px",
                              padding: "6px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              minWidth: "32px",
                              minHeight: "28px",
                              cursor: "pointer",
                              transition: "all 0.2s ease",
                            }}
                            onMouseOver={(e) => {
                              e.currentTarget.style.backgroundColor = "#bbf7d0";
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.backgroundColor = "#dcfce7";
                            }}
                          >
                            <FaEdit style={{ color: "#22c55e", fontSize: "12px" }} />
                          </Button>
                        }
                      />
                    </div>
                  </div>

                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">🤝</div>
                      Mutualisation des plafonds
                    </div>
                    <div className="value-column">
                      <DropDown
                        value={context.state.CorrectionPERMutuPlafond}
                        onChange={(e) => {
                          handleMutuPlafond(e.target.value);
                        }}
                        options={[
                          { value: "non", label: "Non" },
                          { value: "oui", label: "Oui" },
                        ]}
                      />
                    </div>
                    <div className="value-column"></div>
                  </div>
                </div>
              </div>
            </CardBox>
          </Column>

          <Column fill style={{ maxWidth: "640px", display: "flex", flexDirection: "column", height: "100%" }} className="declaration-per-right-column">
            <CardBox bpad className=" blockRoundedForce" style={{ padding: "20px", display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
              
              <Column fill style={{ padding: "10px 5px" }}>
                <div className="action-button-container">
                  <ActionButton
                    onClick={() => {
                      handleResetCorrectionPER();
                    }}
                    icon={FaUndo}
                    title="Réinitialiser"
                    subtitle="Remettre à zéro"
                    colors={{
                      primary: "#3b82f6",
                      secondary: "#1d4ed8",
                      shadow: "rgba(59, 130, 246, 0.4)",
                      shadowHover: "rgba(59, 130, 246, 0.6)",
                    }}
                    decorativeIcon={{ type: "undo" }}
                  />
                  <ActionButton
                    onClick={() => {
                      SyntheseCorrectionPER(context.state, { dispos: tabCorrectionPER, plafondClient: plafondClient, plafondConjoint });
                    }}
                    icon={FaPrint}
                    title="Impression"
                    subtitle="Editer un Word"
                    colors={{
                      primary: "#11998e",
                      secondary: "#0d7377",
                      shadow: "rgba(17, 153, 142, 0.4)",
                      shadowHover: "rgba(17, 153, 142, 0.6)",
                    }}
                    decorativeIcon={{ type: "document" }}
                  />
                   {context.state.Partner === "" && (
                          <>
                  <ActionButton
                    onClick={() => {
                      handleSave();
                    }}
                    icon={FaSave}
                    title="Sauvegarder"
                    subtitle="Sauvegarder l'étude"
                    colors={{
                      primary: "rgb(124, 58, 237)",
                      secondary: "rgb(109, 40, 217)",
                      shadow: "rgba(124, 58, 237, 0.4)",
                      shadowHover: "rgba(124, 58, 237, 0.6)",
                      background: "linear-gradient(135deg, rgb(124, 58, 237) 0%, rgb(109, 40, 217) 100%)",
                    }}
                    decorativeIcon={{ type: "save" }}
                  />
                  <ActionButton
                    onClick={() => {
                      handleGoToAudits();
                    }}
                    icon={FaArrowLeft}
                    title="Quitter"
                    subtitle="Revenir aux audits"
                    colors={{
                      primary: "#e57373",
                      secondary: "#c62828",
                      shadow: "rgba(229, 115, 115, 0.4)",
                      shadowHover: "rgba(229, 115, 115, 0.6)",
                    }}
                    decorativeIcon={{ type: "previous" }}
                  />
                  </>
                  )}
                </div>
              </Column>
            </CardBox>
            <CardBox tpad bpad className="blockRoundedForce" style={{ marginTop: "00px", padding: "25px", flex: 1 }}>
              <div className="revenuspro-container" style={{ marginBottom: "20px", paddingLeft: "0px" }}>
                {/* Titre au-dessus du tableau */}
                <div className="dossier-header" style={{ marginBottom: "15px" }}>
                  <div className="dossier-header-icon">
                    <FaCalculator />
                  </div>
                  <h1 className="dossier-header-title">Plafond de déduction {year}</h1>
                </div>

                {/* Header des colonnes */}
                <div className="header-card">
                  <div className="category-column" style={{ textAlign: "left", flex: 2 }}>
                    Bénéficiaire
                  </div>
                  <div className="value-column" style={{ textAlign: "center" }}>
                    Montant
                  </div>
                </div>

                {/* Conteneur des cartes de contenu */}
                <div className="card-list-container">
                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">👤</div>
                      Client
                    </div>
                    <div className="value-column">
                      <TextField value={plafondClient} disabled dataType="uint" format={{ thousands: " ", unit: " €" }} />
                    </div>
                  </div>

                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">💑</div>
                      Conjoint
                    </div>
                    <div className="value-column">
                      <TextField value={plafondConjoint} disabled dataType="uint" format={{ thousands: " ", unit: " €" }} />
                    </div>
                  </div>
                </div>
              </div>
            </CardBox>
          </Column>
        </Row>
        <CorrrectionPERAnnee
          Year={yearToModify}
          TabCorrectionPER={tabCorrectionPER}
          ClientConjoint={clientConjoint}
          ChangeValue={handleChangeValue}
          CalculCorrectionPER={handleCalcul}
          visible={openModal}
          onClose={() => {
            setOpenModal(false);
          }}
        />
      </Column>
    </>
  );
};

export default CorrectionPER;
